import Constant from '@/common/constant/Constant';
import { useState, useEffect } from 'react';
import { MenuItem, TextField, ListSubheader, Tooltip } from '@material-ui/core';
import Utils from '@/common/utils/utils';

export default function ReplyEmailSubject({
    detailTicket,
    replyToEmailTicket,
    fieldData,
    register,
    setValue,
    triggerEnableBtnSaveTicket = () => {}
}) {
    
    const [defaultSubjectValue, setDefaultSubjectValue] = useState(Utils.isEmptyObject(fieldData.value) ? '' : fieldData.value);
    
    useEffect(() => {
        if (replyToEmailTicket) {
            let tempDefaultSubjectValue = defaultSubjectValue;
            let prefixSubject = 'Re: ';
            if (replyToEmailTicket.ticketType === Constant.TICKET_TYPE.EMAIL && 
                defaultSubjectValue?.substring(0, prefixSubject.length) !== prefixSubject) {
                tempDefaultSubjectValue = prefixSubject + defaultSubjectValue;
                
            }
            setDefaultSubjectValue(tempDefaultSubjectValue);
            register(fieldData.id);
            setValue(fieldData.id, tempDefaultSubjectValue)
        }

    }, [replyToEmailTicket]);


    return (
        <div className='form-addTicket'>
            <div className="cell-prod-status gap-8"><label class="form-addTicket-label">{fieldData?.name?.jp?.text}</label></div>
            <TextField
                fullWidth
                variant="outlined"
                className="form-control-wrapInput form-control-hg40 email-response-address-input"
                value={defaultSubjectValue}
                onChange={e => {
                    setDefaultSubjectValue(e.target.value);
                    setValue(fieldData.id, e.target.value);
                    triggerEnableBtnSaveTicket()
                }}
                onBlur={e => {
                    setDefaultSubjectValue(e.target.value.trim());
                    setValue(fieldData.id, e.target.value.trim());
                }}
            />
        </div>
    );
}
